import { InsightItemModel } from '@_types/organisms';
import Picture from '@atoms/pictures/Picture';
import Link from '@atoms/links/Link';
import RequireCss from '@helpers/RequireCss';
import { getModifiers } from '@helpers/functions';
import Button from '@atoms/buttons/Button';

const InsightTheViewFeaturedItem = (model: InsightItemModel) => {
  const { thumbnail, category, description, title, publishedDate, dataSet, button } = model;
  const styleModifiers = getModifiers(model, 'kf-o-insights-the-view-featured-item');

  return (
    <div className={styleModifiers} {...dataSet}>
      {thumbnail && (
        <div className="kf-o-insights-the-view-featured-item__thumbnail">
          <Picture {...thumbnail} />
        </div>
      )}
      <div className="kf-o-insights-the-view-featured-item__content">
        {category && <p className="kf-o-insights-the-view-featured-item__category">{category}</p>}
        {title && (
          <h3 className="kf-o-insights-the-view-featured-item__title">
            <Link {...title} />
          </h3>
        )}
        {description && <p className="kf-o-insights-the-view-featured-item__description">{description}</p>}
        {publishedDate && <p className="kf-o-insights-the-view-featured-item__published-date">{publishedDate}</p>}
        {button && <Button {...button} className="kf-o-insights-the-view-featured-item__button-read-article" />}
      </div>

      <RequireCss path={'b-insight-the-view-featured-item'} />
    </div>
  );
};

export default InsightTheViewFeaturedItem;
